import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18nextLoader";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { configureAxios } from "./services/ApiService";
import { initKeycloak } from "./services/AuthService";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const renderApp = () =>
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Suspense fallback>
          <App />
        </Suspense>
      </BrowserRouter>
    </React.StrictMode>
  );

// https://github.com/dasniko/keycloak-reactjs-demo
initKeycloak(renderApp);
configureAxios();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
